import {createError} from '#imports';
import {isOutOfBoundsListingPage} from '~/utils/listingPage';

export function assertListingPageInBounds(requestedPage: number, totalPages: number | undefined): void {
    if (!isOutOfBoundsListingPage(requestedPage, totalPages ?? 0)) {
        return;
    }
    throw createError({
        statusCode: 404,
        statusMessage: 'Page not found',
        fatal: true,
    });
}
